import { createBridgeContext } from '@dvag/mfe-bridge';

type MfeEventHandler<THandlers, TOptions> = (
  eventName: string,
  options: TOptions | undefined,
  handlers: THandlers | null,
) => void;

export const createRegisteredChildMfe = <THandlers, TOptions = undefined>(identifier: string) => {
  const bridge = createBridgeContext();
  const connector = bridge.registerChildMFE(identifier);

  let isRegistered = false;
  let latestHandlers: THandlers | null = null;

  const bindHandlers = (handlers: THandlers): (() => void) => {
    latestHandlers = handlers;

    return () => {
      if (latestHandlers === handlers) {
        latestHandlers = null;
      }
    };
  };

  const register = (handler: MfeEventHandler<THandlers, TOptions>): void => {
    if (isRegistered) {
      return;
    }

    isRegistered = true;

    connector.onEventFromMFE((eventName: string, options?: TOptions) => {
      handler(eventName, options, latestHandlers);
    });
  };

  return {
    bindHandlers,
    register,
  };
};
